/* import __COLOCATED_TEMPLATE__ from './admin-company-card.hbs'; */
import { computed } from '@ember/object';
import Component from '@ember/component';
import { showModal } from "sh-www/utils/modal-controls";
import { COMPANY } from 'sh-www/models/company';

const CLASS_NAME = 'SH-c-admin-company-card';

export default Component.extend({
  tagName: '',
  CLASS_NAME,

  /** @param {Company} */
  company: null,

  /** @param {User} */
  user: null,

  changeUser: null,

  /** @param {Function} */
  onEdit: () => {},

  /** @param {Function} */
  onProfileLinkClick: () => {},

  /** @param {Function} */
  onUserCompanyChange: () => {},

  /** @type {String} */
  tierName: computed('company.tier', function () {
    return COMPANY.TIER_NAMES[this.company.tier];
  }),

  /** @type {Ember.A<Ember.Object>} */
  menuOptions: computed('company.{id,name}','changeUser', function () {
    const companyId = this.company.id;

    if (this.changeUser) {
      return [
        {
          title: "Set as user's company",
          hasSeparatorAfter: true,
          onClick: () => {
            const modalModel = {
              titleText: `Set ${this.company.name} as ${this.user.firstName}'s company?`,
              actionButtonText: 'Change Company',
              width: 'medium',
              confirmAction: () => {
                this.onUserCompanyChange(this.changeUser, this.company.id);
              },
            };

            showModal(this, 'confirmation', modalModel)
          },
        },
      ];
    }

    return [
      {
        title: 'Edit Members',
        hasSeparatorAfter: true,
        onClick: () => this.onEdit(companyId, 'members'),
      },
      {
        title: 'Edit Billing',
        hasSeparatorAfter: true,
        onClick: () => this.onEdit(companyId, 'billing'),
      },
      {
        title: 'Edit Legal',
        hasSeparatorAfter: true,
        onClick: () => this.onEdit(companyId, 'legal'),
      },
    ];
  }),

  /** @type {CompanyGroup|null} */
  group: computed('company.groupId', 'company.groups.@each.{id,name}', function () {
    const company = this.get('company');
    const { groupId, groups } = company.getProperties(['groupId', 'groups']);

    if (!groupId || !groups.length) return null;

    return groups.find((group) => group.id === groupId);
  }),

  /** @type {Boolean} */
  isShell: computed('company.type', function () {
    return this.get('company.type') === COMPANY.TYPES.SHELL;
  }),

  actions: {
    /**
     * @param {'user'|'company'} type
     * @param {User|Company} model
     */
    handleProfileLinkClick(type, model) {
      this.get('onProfileLinkClick')(type, model);
    },
  },
});
